import {useRouter} from 'next/router';
import redirects from './index';

const RedirectPage = () => {
  if (typeof window !== 'undefined') {
    const router = useRouter();
    const {asPath} = router;

    Object.keys(redirects).forEach(oldURL => {
      const redirectURL = redirects[oldURL];
      const queryStringArray = asPath.split('?');
      const oldUrlFormatted = oldURL.startsWith('/') ? oldURL : `/${oldURL}`;

      if (
        queryStringArray.length > 0 &&
        queryStringArray[0].toLowerCase() === oldUrlFormatted.toLowerCase()
      ) {
        const queryString = queryStringArray.length > 1 ? `?${queryStringArray[1]}` : ``;
        router.push(`${redirectURL}/${queryString}`);
      }
    });
  }

  return null;
};

export default RedirectPage;
